export enum FlooriThemes {
    default = 3,
}
